(() => {
  const BREAKPOINT = '(max-width: 780px)';
  const START_COLLAPSED = true;

  const BLOCK = '.footer-block.grid__item';
  const HEADING = '.footer-block__heading';
  const TOGGLE = '.footer-block__toggle';

  const mql = window.matchMedia(BREAKPOINT);
  let uid = 0;

  function findPairs(root) {
    return Array.from(root.querySelectorAll(BLOCK))
      .map((block) => {
        const heading = block.querySelector(HEADING);
        const next = heading && heading.nextElementSibling;
        if (!next) return null;
        const isList = next.tagName === 'UL';
        const isPanel = next.classList.contains('footer-block__panel');
        if (!isList && !isPanel) return null;
        return { block, heading, next };
      })
      .filter(Boolean);
  }

  function enable({ block, heading, next }) {
    if (block.dataset.footerAccordion === 'on') return;

    let panel = next;
    if (panel.tagName === 'UL') {
      const wrapper = document.createElement('div');
      wrapper.className = 'footer-block__panel';
      panel.parentNode.insertBefore(wrapper, panel);
      wrapper.appendChild(panel);
      panel = wrapper;
    }

    let button = heading.querySelector(TOGGLE);
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'footer-block__toggle';
      while (heading.firstChild) button.appendChild(heading.firstChild);
      heading.appendChild(button);
    }

    if (!panel.id) panel.id = `FooterPanel-${(uid += 1)}`;
    button.setAttribute('aria-controls', panel.id);

    block.dataset.footerAccordion = 'on';
    setExpanded({ block, button, panel }, !START_COLLAPSED, { animate: false });

    button.addEventListener('click', onClick);
  }

  function disable({ block, heading, next }) {
    if (block.dataset.footerAccordion !== 'on') return;

    const button = heading.querySelector(TOGGLE);
    if (button) {
      button.removeEventListener('click', onClick);
      while (button.firstChild) heading.insertBefore(button.firstChild, button);
      button.remove();
    }

    const panel = next.classList.contains('footer-block__panel') ? next : null;
    if (panel) {
      panel.removeAttribute('inert');
      while (panel.firstChild) panel.parentNode.insertBefore(panel.firstChild, panel);
      panel.remove();
    }

    delete block.dataset.footerAccordion;
    block.classList.remove('footer-block--collapsed', 'footer-block--no-anim');
  }

  function setExpanded({ block, button, panel }, expanded, { animate = true } = {}) {
    if (!animate) {
      block.classList.add('footer-block--no-anim');
      void block.offsetHeight;
    }

    button.setAttribute('aria-expanded', String(expanded));
    block.classList.toggle('footer-block--collapsed', !expanded);
    if (expanded) panel.removeAttribute('inert');
    else panel.setAttribute('inert', '');

    if (!animate) {
      void block.offsetHeight;
      block.classList.remove('footer-block--no-anim');
    }
  }

  function onClick(event) {
    const button = event.currentTarget;
    const block = button.closest(BLOCK);
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!block || !panel) return;

    const expanded = button.getAttribute('aria-expanded') === 'true';
    setExpanded({ block, button, panel }, !expanded);
  }

  function apply(root = document) {
    findPairs(root).forEach(mql.matches ? enable : disable);
  }

  function init() {
    apply();
    if (mql.addEventListener) mql.addEventListener('change', () => apply());
    else if (mql.addListener) mql.addListener(() => apply());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => apply(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target.closest(BLOCK);
    if (!block || !mql.matches) return;
    const button = block.querySelector(TOGGLE);
    const panel = button && document.getElementById(button.getAttribute('aria-controls'));
    if (button && panel) setExpanded({ block, button, panel }, true);
  });
})();
